module.exports = __webpack_public_path__ + "static/shopify_partners-f4030292ac241b6e80b481ae557f3a5f.png";